import { StandardTrackCode } from '@backrs_ui/common-ui';

export const TRACK_IMAGES: Record<StandardTrackCode, string> = {
  'semi-skilled': '/images/careerTracks/semi_skilled.svg',
  trades: '/images/careerTracks/trades.svg',
  'middle-tier': '/images/careerTracks/middle_tier.svg',
  'upper-tier': '/images/careerTracks/upper_tier.svg',
  'top-tier': '/images/careerTracks/top_tier.svg',
};
